<template>
	<v-container>
		<v-sheet color="primary" class="pa-4 rounded-t-lg" dark>
			<v-row>
				<v-col cols="12" class="d-flex justify-center">
					<v-img :src="require('@/assets/logo.svg')" max-height="90" max-width="350"
								 contain transition="scale-transition"/>
				</v-col>
				<v-col cols="12" class="headline text-center">
					Somos el primer gran paso para modernizar tu negocio
				</v-col>
			</v-row>
		</v-sheet>
		<v-sheet color="white" class="pa-4 rounded-b-lg">
			<v-row v-if="esExito">
				<v-col  cols="12" class="headline text-center">
					Pago exitoso
				</v-col>
				<v-col cols="12" class="d-flex flex-column align-center">
					<v-icon color="success" size="128">
						check_circle
					</v-icon>
					<span class="my-2 text-center body-1">
						El pago ha sido exitosamente recibido. Gracias por confiar en nosotros.
					</span>
					<span class="my-2 text-center body-1">
						Su identificador de orden es <b>{{ idOrden }}</b>.
					</span>
					<span class="my-2 text-center body-1">
						Dentro de poco será <b>contactado por nuestros ejecutivos</b> <v-icon>support_agent</v-icon> y
						<b>recibirá información vía e-mail</b> <v-icon>mail_outline</v-icon> para comenzar a usar los productos
						contratados. ¡Quedamos en contacto! <v-icon>sentiment_satisfied_alt</v-icon>
					</span>
				</v-col>
			</v-row>
			<v-row v-if="esCancelado">
				<v-col  cols="12" class="headline text-center">
					Pago cancelado
				</v-col>
				<v-col cols="12" class="d-flex flex-column align-center">
					<v-icon color="warning" size="128">
						warning_amber
					</v-icon>
					<span class="my-2 text-center body-1">
						El pago ha sido cancelado, por lo que la orden <b>{{ idOrden }}</b> fue anulada.
					</span>
					<span class="my-2 text-center body-1">
						<b>No se hizo ningún cargo.</b>
					</span>
					<span class="my-2 text-center body-1">
						Si tuvo problemas con el pago, tiene consultas o necesita alguna configuración especial de productos,
						no dude en contactarnos. Revise nuestros canales de atención en <b><a href="https://vessi.cl/#contacto">vessi.cl</a></b>
						para que le ayudemos <v-icon>sentiment_satisfied_alt</v-icon>.
					</span>
				</v-col>
			</v-row>
		</v-sheet>
	</v-container>
</template>

<script>
const EXITO = 'exito';
const CANCELADO = 'cancelado';

export default {
	components: {
		
	},
	data: () => ({
		
	}),
	computed: {
		estado: function() {
			let vm = this;
			let estadoParam = vm.$route.params['estado'];
			let hayEstadoParam = (estadoParam !== undefined);
			let estado = hayEstadoParam ? estadoParam : undefined;
			return estado;
		},
		esExito: function() {
			let vm = this;
			let estado = vm.estado;
			let esExito = (estado === EXITO);
			return esExito;
		},
		esCancelado: function() {
			let vm = this;
			let estado = vm.estado;
			let esCancelado = (estado === CANCELADO);
			return esCancelado;
		},
		idOrden: function() {
			let vm = this;
			let idOrdenParam = vm.$route.params['idorden'];
			let hayidOrdenParam = (idOrdenParam !== undefined);
			let idOrden = hayidOrdenParam ? idOrdenParam : undefined;
			return idOrden;
		},
	},
	methods: {
		// Nada
	},
	watch: {
		// Nada
	},
};
</script>
